import { useParams } from 'quartz-routing/react-router';
import { PLAYLIST_SEARCH_PARAM } from '../playlistContent/playlistContentConsts';
// @ts-expect-error Could not find a declaration file for module
import { useSearchParam } from '../../hooks/searchParamHooks';
export { useShortVideo } from 'academy-common-lib/features/shortContent/shortContentHooks';
export const useShortContentParams = () => {
  const {
    shortId,
    playlistNavigation
  } = useParams();
  const [[playlistIdParam]] = useSearchParam(PLAYLIST_SEARCH_PARAM);
  return {
    shortId: shortId ? Number(shortId) : undefined,
    playlistId: playlistIdParam ? Number(playlistIdParam) : undefined,
    playlistNavigation
  };
};